import React from 'react';
import { wechatLogin } from 'utils/wxUtils';
import { Flex } from 'antd-mobile';
import CommonBtn from 'pubBiz/CommonBtn/CommonBtnView';
import { ImgWrap } from 'pubBiz';

import styles from './index.modules.less';

const LoginBottomTip = ({ goToTop = () => {}, showGoToTop, onLogin = () => {} }) => {
  return (
    <div className={styles['to-register-tip']}>
      <img className={styles['tip-icon']} src={`${CDN_BASE}/assets/imgs/common/icon_robot.png`} />
      <span className={styles['tip-desc']}>立即注册享受新人超值套餐</span>
      <Flex>
        <CommonBtn
          className={styles['tip-button']}
          title="立即登录"
          onClick={() => {
            onLogin();
            wechatLogin();
          }}
        />
        {!!showGoToTop && (
          <div onClick={goToTop}>
            <ImgWrap
              src="https://image.yofogo.com/images/login-reg/goTop.png"
              mode="full"
              w="56px"
              h="56px"
              className={styles['tip-go-top']}
            />
          </div>
        )}
      </Flex>
    </div>
  );
};

export default LoginBottomTip;



// WEBPACK FOOTER //
// ./src/components/LoginBottomTip/index.js